<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
      <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["companyNo"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.companyName">
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["empId"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.empId">
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["empName"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.empName">
          </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["sex"]}}</span>
            <input type="text" class="form-control"  readonly='true' :value='data.sex==1? rs["sex1"]:rs["sex2"]'>
          
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["deptNo"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.deptName">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["xgroup"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.xgroup">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["duty"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.duty">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["jobTitle"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.jobTitle">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["job"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.job">
        </div>
    </div>
    <br>
    
    <fieldset style="padding: none; margin: 5px 5px 5px 5px; border: 1px solid #191717;">
      <legend style="width: auto; margin-left: 50px; margin-bottom:0;"><label for=rb_Employee>员工薪资</label></legend>
    <div class="row">
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["salaryBase"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.basePay" >
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["jobPay"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.jobPay" >
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["restDays"]}}</span>
            <select v-model="data.salaryEmp.restDays" v-bind:disabled='action=="View"' class="form-control">
              <option value="-2">{{rs["restType_2"]}}</option>
              <option value="-1">{{rs["restType_1"]}}</option>
              <option value="0">无</option>
              <option value="1">1天</option>
              <option value="2">2天</option>
              <option value="3">3天</option>
              <option value="4">4天</option>
              <option value="5">5天</option>
              <option value="6">6天</option>
              <option value="7">7天</option>
              <option value="8">8天</option>
            </select>
          </div>  
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["foodSubsidy"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.foodSubsidy" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["meritsPay"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.meritsPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["fullAttdPay"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.fullAttdPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["workMonthPay"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.workMonthPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["hotPay"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.hotPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["socialSecurity"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.socialSecurity" >
        </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["sname"]}}</span>            
            <select v-model="data.salaryEmp.scode" v-bind:disabled='action=="View"' class="form-control">
              <option v-for="dt in config.smethod" :value="dt.scode">{{dt.sname}}</option>
            </select>
          </div>
      </div>
      <div class="row">
        <div class="input-group col-md-4"><span class="input-group-addon" >{{rs["bankAccount"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.bankAccount" >
        </div>  
        <div class="input-group col-md-4"><span class="input-group-addon" >{{rs["bankName"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryEmp.bankName" >
        </div>  
      </div>
     </fieldset>
    <br>
    <fieldset style="padding: none; margin: 5px 5px 5px 5px; border: 1px solid #191717;">
      <legend style="width: auto; margin-left: 50px; margin-bottom:0;"><label for=rb_Employee>专项附加扣除</label></legend>
      <div>
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["taxChild"]}}</span>
          <input type="number" class="form-control" v-model="data.salaryEmp.taxChild" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["taxEducation"]}}</span>
          <input type="number" class="form-control" v-model="data.salaryEmp.taxEducation" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["taxLoan"]}}</span>
          <input type="number" class="form-control" v-model="data.salaryEmp.taxLoan" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["taxRent"]}}</span>
          <input type="number" class="form-control" v-model="data.salaryEmp.taxRent" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["taxParent"]}}</span>
          <input type="number" class="form-control" v-model="data.salaryEmp.taxParent" >
        </div> 
      </div>
    </fieldset>
    <br>
    <fieldset style="padding: none; margin: 5px 5px 5px 5px; border: 1px solid #191717;">
      <legend style="width: auto; margin-left: 50px; margin-bottom:0;"><label for=rb_Employee>岗位薪资</label></legend>
      <div>
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["salaryBase"]}}</span>
            <input type="number" class="form-control" readonly="true" v-model="data.salaryJob.basePay" >
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["jobPay"]}}</span>
            <input type="number" class="form-control" readonly="true" v-model="data.salaryJob.jobPay" >
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["restDays"]}}</span>
            <select v-model="data.salaryJob.restDays" disabled v-bind:disabled='action=="View"' class="form-control">
              <option value="-2">{{rs["restType_2"]}}</option>
              <option value="-1">{{rs["restType_1"]}}</option>
              <option value="0">无</option>
              <option value="1">1天</option>
              <option value="2">2天</option>
              <option value="3">3天</option>
              <option value="4">4天</option>
              <option value="5">5天</option>
              <option value="6">6天</option>
              <option value="7">7天</option>
              <option value="8">8天</option>
            </select>
          </div>  
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["foodSubsidy"]}}</span>
          <input type="number" class="form-control"  readonly="true" v-model="data.salaryJob.foodSubsidy" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["meritsPay"]}}</span>
          <input type="number" class="form-control"  readonly="true" v-model="data.salaryJob.meritsPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["fullAttdPay"]}}</span>
          <input type="number" class="form-control"  readonly="true" v-model="data.salaryJob.fullAttdPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["workMonthPay"]}}</span>
          <input type="number" class="form-control" readonly="true" v-model="data.salaryJob.workMonthPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["hotPay"]}}</span>
          <input type="number" class="form-control" readonly="true" v-model="data.salaryJob.hotPay" >
        </div> 
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["socialSecurity"]}}</span>
          <input type="number" class="form-control" readonly="true" v-model="data.salaryJob.socialSecurity" >
        </div> 
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["sname"]}}</span>            
            <select v-model="data.salaryJob.sname" disabled class="form-control">
              <option v-for="dt in config.smethod" :value="dt.scode">{{dt.sname}}</option>
            </select>
          </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import mixin from "@/fui/mixin";
export default {
  methods: {
    checkInput(){
      //this.data.salaryEmp.companyNo = this.data.companyNo
      //this.data.salaryEmp.companyName = this.data.companyName
      //this.data = this.data.salaryEmp
       //if (!this.checkNull(this.data.scode, "nullId")) return false 
       //if (!this.checkNull(this.data.sname, "nullName")) return false 
       return true
    },
    save(){
      const m = this.config.smethod.find(d=>{
        return d.scode==this.data.salaryEmp.scode
      })
      if (m) this.data.salaryEmp.sname = m.sname
      this.data.salaryEmp.companyNo = this.data.companyNo
      this.data.salaryEmp.companyName = this.data.companyName
      this.$save(this.url + "Edit", this.data.salaryEmp, this.saveResult)
    }
  },
  mixins: [mixin.detail]
}
</script>
